import Helpers from '@helpers';
import * as React from 'react';
import { specialOffer } from './specialOffer';
import { priceChecker } from './priceChecker';

class ProductPriceListEditController extends React.Component {
    constructor(props) {
        super(props);
    }

    public componentDidMount() {

        specialOffer();

        function activateSearchTab() {
            $('#divSearch').show();
            $('#divBulkChange').hide();
            $('.tab').removeClass('tab-active');
            $('#tabSearch').addClass('tab-active');
        }

        function activateChangeTab() {
            $('#divSearch').hide();
            $('#divBulkChange').show();
            $('.tab').removeClass('tab-active');
            $('#tabBulkChange').addClass('tab-active');
        }

        priceChecker();

        //$('.price-warning').focusout(function (e) {

        //    $('#ContentPlaceHolder1_priceCheck_10Submit').unbind();
        //    $('#ContentPlaceHolder1_priceCheck_10Cancel').unbind();
        //    $('#priceCheck_10 .close-link').unbind();
        //    $('#modalMask').unbind();

        //    const textBox = $(this);
        //    const hiddenField = $(this).next();
        //    const textBoxVal = parseInt(textBox.val().toString().replace(/,/g, ''), 10);
        //    const hiddenFieldVal = parseInt(hiddenField.val().toString(), 10);
        //    const taghirat = hiddenFieldVal * 0.1;
        //    const bigChangeUp = hiddenFieldVal * 2;
        //    const bigChangeDown = hiddenFieldVal * 0.5;


        //    if (textBoxVal > (hiddenFieldVal + taghirat) || textBoxVal < (hiddenFieldVal - taghirat)) {
        //        $(this).css('border-color', 'red');

        //        $('#priceCheck_10').show();
        //        $('#modalMask').show();
        //        $('#ContentPlaceHolder1_priceCheck_10Submit').click(confirm);
        //        $('#ContentPlaceHolder1_priceCheck_10Cancel').click(cancel);
        //        $('#priceCheck_10 .close-link').click(cancel);
        //        $('#modalMask').click(cancel);

        //        function confirm() {
        //            $('#priceCheck_10').hide();
        //            $('#modalMask').hide();
        //        }
        //        function cancel() {
        //            textBox.css('border-color', '#d7d7d7');
        //            $('#priceCheck_10').hide();
        //            $('#modalMask').hide();
        //            textBox.val(Helpers.Utils.numberWithCommas(hiddenField.val()));
        //        }
        //    }

        //    if (textBoxVal > bigChangeUp || textBoxVal < bigChangeDown) {
        //        $(this).css('border-color', 'red');

        //    }
        //});

        $('.hideMeShowNext').click(function() {
            $(this).hide();
            $(this).next().show();
        });

        $('#txtChangePricePercent').on('keyup mouseup', function() {
            const percentage = parseInt($(this).val().toString(), 10);
            $('.ui-price-textbox').each(function() {
                const price = parseInt($(this).parent().find('input:hidden').val().toString(), 10);
                if (!isNaN(percentage)) {
                    const computedValue = price + (price * percentage / 100);
                    $(this).val(Helpers.Utils.numberWithCommas(computedValue));
                } else {
                    $(this).val(Helpers.Utils.numberWithCommas(price));
                }
            });
        });

        $('#drpChangeAvailability').change(function() {
            const newValue = $(this).val();
            $('.ui-price-instock-checkbox').each(function() {
                const checkbox = $(this).find('input:checkbox');
                if (newValue === 'true') {
                    checkbox.prop('checked', true);
                } else if (newValue === 'false') {
                    checkbox.prop('checked', false);
                } else {
                    const initValue = $(this).parent().find('input:hidden').val().toString().toLowerCase();
                    if (initValue === 'true') {
                        checkbox.prop('checked', true);
                    } else {
                        checkbox.prop('checked', false);
                    }
                }
            });
        });

        $('#tabSearch').click(() => {
            activateSearchTab();
        });

        $('#tabBulkChange').click(() => {
            activateChangeTab();
        });

        $('.ui-price-image, .ui-price-title').click(function() {
            const link = $(this).next().val().toString();
            const win = window.open(link, '_blank');
            if (win) {
                win.focus();
            } else {
                alert('Please allow popups for this website');
            }
        });

        activateSearchTab();
    }

    public render() {
        return null;
    }
}

Helpers.ReactHelper.createReactElement('ProductPriceListEditController', ProductPriceListEditController);
